var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPauseButtonAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Play_button",
    "data-name": "Play button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1",
    "data-name": "Ellisse 1",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon-pause",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    "data-name": "Tracciato 13",
    d: "M0,0H30V30H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_31",
    "data-name": "Rettangolo 31",
    width: 4,
    height: 20,
    transform: "translate(8 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_32",
    "data-name": "Rettangolo 32",
    width: 4,
    height: 20,
    transform: "translate(18 5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPauseButtonAlt);
export default __webpack_public_path__ + "static/media/icon-pause-button-alt.61aed598744d7a30d6b2cbe82d537e90.svg";
export { ForwardRef as ReactComponent };